export default "__VITE_ASSET__BDM_llW8__"